import React from 'react';
import PropTypes from 'prop-types';

const Form = ({ newTaskSubmitHandler, taskName, addNewTaskName }) => (
  <form className='additem' onSubmit={newTaskSubmitHandler}>
    <input
      className='add-task'
      type='text'
      placeholder='Add new task'
      value={taskName}
      onChange={addNewTaskName}
    />
    <button
      className='addBtn'
      type='submit'
      name='submit'
      onClick={newTaskSubmitHandler}
    >
      <i className='fas fa-plus-circle' />
    </button>
  </form>
);

Form.propTypes = {
  newTaskSubmitHandler: PropTypes.func.isRequired,
  taskName: PropTypes.string.isRequired,
  addNewTaskName: PropTypes.func.isRequired
};

export default Form;
